import { Alert, Button, Slide, TextField } from "@mui/material";
import { Box } from "@mui/system";
import { Icon } from "leaflet";
import "leaflet/dist/leaflet.css";
import { useContext, useState } from "react";
import { MapContainer, Marker, TileLayer } from "react-leaflet";
import { useLocation } from "react-router-dom";
import { ClientContext } from "../../../store/context";
import { Post } from "../../api/ApiCallerService";
import { emailApi, keysApi, siteValuesApi } from "../../api/GardenoApi";
import { usePost } from "../../hooks/Hooks";
import {
  aboutSettings,
  aboutValues,
  colorPallete,
} from "../../utils/constants";
import {
  convertToLanguage,
  findObgjectInArray,
  isEmail,
} from "../../utils/generalUtils";
import "./AboutPage.css";
function AboutPage(props) {
  const { state } = useLocation();
  const [name, setName] = useState(null);
  const [lastName, setlastName] = useState(null);
  const [email, setEmail] = useState(null);
  const [phone, setPhone] = useState(null);
  const [comments, setComments] = useState(null);
  const [flag, setFlag] = useState(false);
  const position = [39.39616101547302, 20.022791659575027];
  const validMail = !isEmail(email);
  const { language } = useContext(ClientContext);
  const [showAlert, setShowAlert] = useState(false);
  const [settings, settigsError] = usePost(
    keysApi.getAllKeys,
    convertToLanguage(language),
    aboutSettings
  );
  const [values, valuesError] = usePost(
    siteValuesApi.getAllValues,
    convertToLanguage(language),
    aboutValues
  );

  const locationIcon = new Icon({
    iconUrl: "https://cdn-icons-png.flaticon.com/512/447/447031.png",
    iconSize: [35, 35],
  });

  return (
    <div className="about-page-content">
      <div style={{ width: "100%", height: "400px" }}>
        <MapContainer center={position} zoom={16} scrollWheelZoom={false}>
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <Marker position={position} icon={locationIcon} />
        </MapContainer>
      </div>
      <Box
        className="about-page-contact-container"
        sx={{
          justifyContent: "space-between",
          flexDirection: { xs: "column", lg: "row" },
        }}
      >
        <div style={{}}>
          <h1>{settings?.settings.CONTACT_US}</h1>
          <span>
            {values != null
              ? findObgjectInArray(values, "name", "SITE_NAME")["value"]
              : ""}
          </span>
          <span>{settings?.settings.CONTACT_ADDRESS}</span>
          <span>{`${settings?.settings.CONTACT_PHONE} : ${
            values != null
              ? findObgjectInArray(values, "name", "SITE_NUMBER")["value"]
              : ""
          }`}</span>
          <a
            style={{ color: colorPallete.vividLightBlue }}
            href="https://www.google.com/maps/place/Carental+gardenos/@39.3960056,20.0222542,18z/data=!4m6!3m5!1s0x135c9922e3fdeff9:0xd4016848f72299be!8m2!3d39.3960865!4d20.022737!16s%2Fg%2F11gx_43sb8?entry=ttu"
          >
            {settings?.settings.CONTACT_LOCATION_GMAPS}
          </a>
        </div>
        <div style={{ rowGap: "10px" }}>
          <h1>{settings?.settings.SEND_REQUEST_HEADER}</h1>
          <Box
            component="form"
            noValidate
            autoComplete="off"
            sx={{
              display: "flex",
              gap: "10px",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <Box
              sx={{
                display: "flex",
                gap: "10px",
                justifyContent: "space-between",
                flexDirection: { xs: "column", lg: "row" },
              }}
            >
              <TextField
                error={flag && !name}
                value={name}
                sx={{ width: "100%" }}
                onChange={(event) => setName(event.target.value)}
                required
                label={settings?.settings.FIRST_NAME}
              />
              <TextField
                error={flag && !lastName}
                sx={{ width: "100%" }}
                onChange={(event) => setlastName(event.target.value)}
                required
                label={settings?.settings.LAST_NAME}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                gap: "10px",
                justifyContent: "space-between",
                flexDirection: { xs: "column", lg: "row" },
              }}
            >
              <TextField
                error={(flag && !email) || (email && !isEmail(email))}
                onChange={(event) => setEmail(event.target.value)}
                required
                sx={{ width: "100%" }}
                label={settings?.settings.EMAIL}
              />
              <TextField
                onChange={(event) => setPhone(event.target.value)}
                label={settings?.settings.TELEPHONE}
                sx={{ width: "100%" }}
              />
            </Box>
          </Box>
          <TextField
            required
            error={flag && !comments}
            onChange={(event) => setComments(event.target.value)}
            multiline
            label={settings?.settings.YOUR_MESSAGE}
            rows={4}
            sx={{ width: "100%" }}
          />
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            {!showAlert ? (
              <Button
                onClick={() => {
                  if (name && lastName && email && isEmail(email) && comments) {
                    setFlag(false);
                    const body = {
                      firstName: name,
                      lastName: lastName,
                      email: email,
                      telephone: phone,
                      message: comments,
                      pickUpDate: state?.pickUpDate ?? null,
                      dropOffDate: state?.dropOffDate ?? null,
                      pickUpLocation: state?.pickUpLocation ?? null,
                      dropOffLocation: state?.dropOffLocation ?? null,
                      vehicleName: state?.title ?? null,
                    };
                    Post(emailApi.sendEmail, language, body).then(
                      (response) => {
                        response.ok ? setShowAlert(true) : setShowAlert(false);
                      }
                    );
                  } else {
                    setFlag(true);
                  }
                }}
                variant="outlined"
              >
                {settings?.settings.CONTACT_US}
              </Button>
            ) : (
              <Slide direction="right" in={showAlert}>
                <Alert severity="success">
                  {settings?.settings.CONTACT_EMAIL_SUCCESS}
                </Alert>
              </Slide>
            )}
          </div>
        </div>
      </Box>
    </div>
  );
}

export default AboutPage;
